import React, { useEffect } from "react";
import { Switch } from "react-router-dom";
import { useTracking } from "react-tracking";
import AuthLayout from "../layouts/AuthLayout";
import trackingService from "../services/trackingService";
import trackingConstants from "../constants/trackingConstants";
import { protectedRoutes } from "../routes";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { SnackbarProvider as VendingMachine } from "notistack";
import RouteMapper from "./RouteMapper";
import TutorialTracker from "./TutorialTracker";
import CookieJar from "./CookieJar";
import { useAuth } from "../contexts/authContext";
import * as FlexWebChat from "@twilio/flex-webchat-ui";

const AuthenticatedApp = () => {
    const { impersonatingUser, user } = useAuth();       

    useEffect(() => {

        if (!user)
            return;
        
        const appConfig = {
            accountSid: process.env.REACT_APP_TWILIO_ACCOUNTSID,
            flexFlowSid: process.env.REACT_APP_TWILIO_FLEXFLOWSID,
            context: {
                friendlyName: `${user.details.firstName} ${user.details.lastName}`,
                from: user.details.email
            },
            componentProps: {
                MessagingCanvas: {
                    memberDisplayOptions: {
                        yourDefaultName: 'You',
                        yourFriendlyNameOverride: false,
                        theirFriendlyNameOverride: true
                    }
                },
            },
        };

        console.log({ user, appConfig });

        FlexWebChat.renderWebChat(appConfig);
    }, [user]);

    const { Track } = useTracking(
        {
            app: trackingConstants.appName,
            isImpersonationSession: !!impersonatingUser,
        },
        {
            dispatch: trackingService.sendTrackingData,
            process: (ownTrackingData) =>
                ownTrackingData.page
                    ? { event: trackingConstants.events.pageView }
                    : null,
        }
    );

    return (
        <Track>
            <AuthLayout>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <VendingMachine maxSnack={3}>
                        <TutorialTracker />
                        <CookieJar />
                        <Switch>
                            <RouteMapper routes={protectedRoutes} />
                        </Switch>
                    </VendingMachine>
                </MuiPickersUtilsProvider>
            </AuthLayout>
        </Track>
    );
};

export default AuthenticatedApp;
